import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  isGreenReturnFromModel,
  validateIsGreenReturnCondition,
  type IsGreenReturnState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const IS_GREEN_RETURN = (
  Details: React.ComponentType<ConditionTypeDetailsProps<IsGreenReturnState>>,
): ConditionType<IsGreenReturnState, Condition.IsGreenReturn> => ({
  name: CONDITION_NAMES[Condition.IS_GREEN_RETURN],
  description(state) {
    return t("All items in the return are green returns");
  },
  Details(props: ConditionTypeDetailsProps<IsGreenReturnState>) {
    return React.createElement(Details, props);
  },
  empty: false,
  fromModel(model) {
    return isGreenReturnFromModel(model);
  },
  toModel(state) {
    return { type: Condition.IS_GREEN_RETURN };
  },
  valid(state) {
    return validateIsGreenReturnCondition(state).valid;
  },
});
